import React, { useEffect, useRef } from "react";
import OktaSignIn from "@okta/okta-signin-widget";
import "../../../node_modules/@okta/okta-signin-widget/dist/css/okta-sign-in.min.css";
import config from "../../config";
import BecomeClient from "../BecomeClient";
const Login = ({ onSuccess, onError }) => {
  const widgetRef = useRef();
  useEffect(() => {
    if (!widgetRef.current) {
      return false;
    }
    var widget;
    var location;
    if (window.location.href.includes("clientdevcf")) {
      widget = new OktaSignIn(config.devConfig.widget);
      location = "dev";
    } else if (window.location.href.includes("clienttestcf")) {
      widget = new OktaSignIn(config.testConfig.widget);
      location = "test";
    } else if (window.location.href.includes("clientuatcf")) {
      widget = new OktaSignIn(config.uat.widget);
      location = "uat";
    }else if (window.location.href.includes("clientuatbcf")) {
    widget = new OktaSignIn(config.uatb.widget);
    location = "uat";
    } else if (window.location.href.includes("clientcf")) {
      widget = new OktaSignIn(config.prodConfig.widget);
      location = "prod";
    } else {
      widget = new OktaSignIn(config.localhost.widget);
      location = "local";
    }
     var cookies = document.cookie.split(";");
     for (var i = 0; i < cookies.length; i++) {
       var spcook = cookies[i].split("=");
       document.cookie = spcook[0] + "=;expires=Thu, 21 Sep 1979 00:00:01 UTC;";
     }
    //comment
    // Search for URL Parameters to see if a user is being routed to the application to recover password
    var searchParams = new URL(window.location.href).searchParams;
    widget.otp = searchParams.get("otp");
    widget.state = searchParams.get("state");
	  var target = searchParams.get("target");
    widget
      .showSignInToGetTokens({
        el: widgetRef.current,
      })
      .then(onSuccess => {
        console.log(onSuccess);
        if (onSuccess) {
          document.cookie = "whlOkta" + "=" + 'Bearer ' + onSuccess.accessToken.accessToken+";path=/;domain=.freedomwholesale.com";
         if(target == 'our-process'){
			  window.location = window.location.origin + "/#/dashboard/our-process";
		  }else if(target == 'resources'){
			  window.location = window.location.origin + "/#/forms-and-disclosure";
		  }else{
			window.location = window.location.origin + "/#/dashboard";
		  }
          // if (location === "dev") {
            //   window.location = "https://clientdevcf.freedomwholesale.com/#/dashboard";
          // } else if (location === "test") {
            //   window.location = "https://clienttestcf.freedomwholesale.com/#/dashboard";
          // } else {
            //   window.location = "http://localhost:8080/#/dashboard";
          // }
          
        }
        })
        .catch(onError);
      
    return () => widget.remove();
  }, [onSuccess, onError]);
  return (
    <div className="loginWrapper">
      <div ref={widgetRef} className="widgetWrapper" />
      <BecomeClient className="beClient"></BecomeClient>
      <div className="info">
        <ul>
          <p>
            <strong>IMPORTANT INFORMATION ABOUT YOUR LOGIN:</strong>
          </p>
          <div>
          <li>
            The Freedom Mortgage Wholesale Portal requires you to enter the verification code sent to your email or phone during the login process.
          </li>
          <li>
            If you attempted to reset your password but did not receive a reset link within 5 minutes, contact&nbsp;
            <a href="mailto:ServiceDeskWsale@FreedomMortgage.com">
              ServiceDeskWsale@FreedomMortgage.com
            </a>
            &nbsp;for assistance.
          </li>
          <li>
            Please update your bookmark to the new login link:&nbsp;
            <a
              href="https://clientcf.freedomwholesale.com/Login/index.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://clientcf.freedomwholesale.com/Login/index.html
            </a>
            .
          </li>
          </div>
        </ul>
      </div>
    </div>
  );
};

export default Login;
